import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { BnplService } from '../../shared/services/bnpl.service';
import { CreditApprobe } from 'src/app/core/shared/models/credit-approbe.model';
import Swal from 'sweetalert2';
import { StepsInformation } from '../../shared/models/stepsInformation.model';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { Client } from '../../shared/models/client.model';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { MatDialog } from '@angular/material/dialog';
import { ModalCancelComponent } from '../modal-cancel/modal-cancel.component';
@Component({
  selector: 'app-summary-credit',
  templateUrl: './summary-credit.component.html',
  styleUrls: ['./summary-credit.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SummaryCreditComponent implements OnInit, OnDestroy {
  public summaryCredit: CreditApprobe;
  public personalInformation: StepsInformation;
  public clientInformation: Client;
  public fees: number = 6;
  public feesBenefits: number = 3.0;
  faAngle = faAngleDown;
  public circleInfo = faCircleInfo;
  numeroCuotas = localStorage.getItem('fees') || '';
  partnerName = localStorage.getItem('partnerName') || '';
  channel: string = localStorage.getItem('C') || '';
  navigationExtras: NavigationExtras = {};

  text1: string = `
    <div style="max-height: 200px; overflow-y: visible; color: white; text-align: justify;">
      <p style="padding: 0.5rem;">FGA Fondo de Garantías es una compañía que actúa como fiador 
      para respaldar los créditos de las personas facilitando su aprobación. 
      Este valor, corresponde la fianza que respalda el préstamo aprobado,
      es un % de comisión, sobre el monto del crédito y será divido para 
      pago en el número de cuotas del crédito.</p>
    </div>`;

  text2: string = `
      <div style="max-height: 200px; overflow-y: visible; color: white; text-align: justify;">
        <p style="padding: 0.5rem;">Valor unico de $20.000 distribuido en el número de cuotas del crédito.</p>
      </div>`;

  text3: string = `
    <div style="max-height: 200px; overflow-y: visible; color: white; text-align: justify;">
      <p style="padding: 0.5rem;">2% del monto a financiar distribuido en el número de las cuotas del crédito.</p>
    </div>`;

  text4: string = `
      <div style="max-height: 200px; overflow-y: visible; color: white; text-align: justify;">
        <p style="padding: 0.5rem;">
          El seguro de Plan Deudores Integral respaldado por Seguros Sura te acompaña para asegurar tu futuro y el de aquellos que más quieres. 

Conoce las coberturas del seguro:

Si algo te pasa (fallecimiento) 
Si falleces, el seguro se encarga de pagar la deuda que tienes con Aprobbe. Así, tus seres queridos no tendrán que preocuparse por nada.

Si no puedes trabajar (invalidez)
Si sufres una enfermedad o un accidente que te impide trabajar, el seguro cubre el valor de tu deuda. Así, puedes concentrarte en recuperarte sin la presión de las deudas.

Si pierdes tu ingreso (desempleo)
Si te quedas sin trabajo, el seguro te ayuda a pagar hasta 3 cuotas de tu crédito. Esto te da un respiro mientras encuentras un nuevo empleo.
        </p>
      </div>`;

  signatureValue: number = 0;

  constructor(
    private readonly router: Router,
    private readonly bnplService: BnplService,
    public dialog: MatDialog
  ) {
    this.summaryCredit = this.bnplService.creditCupo;
    this.personalInformation = this.bnplService.stepsInformation;
    this.clientInformation = this.bnplService.stepsInformation.thirdStep.client;
  }
  ngOnDestroy(): void {
    const body = document.querySelector('body');
    if (body !== null) {
      body.style.backgroundColor = '#FAFAFA';
    }
  }

  ngOnInit(): void {
    const body = document.querySelector('body');
    if (body !== null) {
      body.style.backgroundColor = '#7DFFB2';
    }
    Swal.close();
    this.handleSignatureValue();
  }

  navigatePayment() {
    this.bnplService.alertWait();
    if (this.summaryCredit.validationStrategy == 'OK') {
      const data = {
        actionStrategyPattern: 'CONSUME_CUPOS',
        id:
          this.bnplService.personalInformation.id || localStorage.getItem('id'),
        ammount:
          this.bnplService.personalInformation.ammount ||
          localStorage.getItem('ammount'),
        cupo: this.bnplService.creditEmit.amountFinance,
      };
      this.bnplService.getCreditCupo(data).subscribe((resp: any) => {
        this.navigationExtras = { state: resp };

        if (resp.showMessage == 2) {
          Swal.close();
          this.router.navigate(
            ['/await-alert', 'error'],
            this.navigationExtras
          );
        }

        if (resp.errorMessage) {
          this.router.navigate(['/await-alert', 'error-connection']);
        }

        if (resp != null) {
          this.getBoucher().subscribe((res: any) => {
            this.bnplService.dataTemplate = res;
            this.bnplService.payment = resp;
            if (this.bnplService.creditCupo.validationStrategy == 'OK') {
              this.router.navigate(['/payment']);
            }
          });
        }
      });
    }

    if (this.summaryCredit.validationStrategy == 'DOCUMENT') {
      this.getBoucher().subscribe((res: any) => {
        this.bnplService.dataTemplate = res;
        this.router.navigate(['/sign-documents']);
      });
    }
  }

  getBoucher() {
    const dataBpucher = {
      actionStrategyPattern: 'BOUCHER_CREDITS',
      identificacion:
        this.bnplService.personalInformation.identificacion ||
        this.bnplService.stepsInformation.firstStep.numeroDocumento,
    };

    return this.bnplService.getDataBoucher(dataBpucher);
  }

  openInfoPlatform() {
    Swal.fire({
      html: `
      <div style="max-height: 200px; overflow-y: auto; color: white; text-align: justify;">
      <p></p>
    </div>
      `,
      showConfirmButton: true,
      customClass: {
        popup: 'custom-popup',
      },
    });
  }

  openTermConditions(numberText: number) {
    let text;
    if (numberText == 1) {
      text = this.text1;
    }

    if (numberText == 2) {
      text = this.text2;
    }

    if (numberText == 3) {
      text = this.text3;
    }

    if (numberText == 4) {
      text = this.text4;
    }

    Swal.fire({
      html: text,
      showConfirmButton: true,
      customClass: {
        popup: 'custom-popup',
      },
    });
  }

  openModal() {
    const dialogRef = this.dialog.open(ModalCancelComponent);
  }

  handleSignatureValue() {
    if (this.summaryCredit.signature > 0) {
      this.signatureValue =
        this.summaryCredit.signature / this.summaryCredit.fees;
    }
  }
}
